import React from "react";
import SVGInline from "react-svg-inline";

/* eslint import/no-webpack-loader-syntax: off */
import logoObersoundSVG from "!raw-loader!../images/logos/logo-obersound.svg";

import logoOberflex from "../images/brands/oberflex-black.svg";
import logoMarotte from "../images/brands/marotte-black.svg";
import logoPurePaper from "../images/brands/purepaper-black.svg";

import logoObersurface from "../images/brands/obersurfaces.svg";

const Maintenance = () => (
  <div className="maintenance">
    <div className="maintenance__content">
      <div className="mv4">
        <div>
          <SVGInline height={"70px"} svg={logoObersoundSVG} width={"270px"} />
        </div>
        <div className="mb6 f6">Solutions acoustiques par Ober Surfaces</div>
        <div className="mb6">Coming soon...</div>

        <section>
          <div className="pb1">
            Des perforations acoustiques appliquées aux surfaces
          </div>
          <div>
            <img
              className="maintenance__brand maintenance__brand--oberflex"
              src={logoOberflex}
              alt="Oberflex"
            />
            <img
              className="maintenance__brand"
              src={logoMarotte}
              alt="Marotte"
            />
            <img
              className="maintenance__brand maintenance__brand--purepaper"
              src={logoPurePaper}
              alt="Pure Paper"
            />
          </div>
        </section>

        <hr className="maintenance__separator" />

        <section>
          <div className="maintenance__text">
            Des motifs originaux imaginés par le{" "}
            <span className="font-bold">studio 5•5</span> comme outils
            d’expression pour les architectes sensibles aux détails de leurs
            projets.
          </div>
        </section>

        <hr className="maintenance__separator" />

        <section>
          <div className="maintenance__text">
            Une nouvelle collection de 6 perforations à moduler pour donner
            naissance à une infinité de modèles perforés & un nouvel outil
            digital pour configurer des modèles de panneaux acoustiques
            personnalisés.
          </div>
        </section>

        <hr className="maintenance__separator" />

        <section>
          <div className="maintenance__text">
            Des indicateurs de performances acoustiques détaillés pour chaque
            modèle dans une fiche technique illustrée téléchargeable avec image
            HD.
          </div>
          <div className="mv6">
            <img
              className="maintenance__obersurfaces-logo"
              src={logoObersurface}
              alt="OberSurfaces"
            />
          </div>
        </section>

        <section>
          Pour plus d'informations, contactez-nous :{" "}
          <a className="black" href="mailto:prescription@ober-surfaces.com">
            prescription@ober-surfaces.com
          </a>
        </section>
      </div>
    </div>
  </div>
);

export default Maintenance;



// WEBPACK FOOTER //
// ./src/components/Maintenance.js